//------------- DATAGRID USERS COMPONENT ---------

//datagrid da página de técnicos
//fica ao lado do formulário

//importações
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "./styles.css";

import InputSearch from "../inpt-search";

import Requests from "../../services/requests";

//icons
import { BiCalendar, BiRefresh } from "react-icons/bi";
import { FaTrashAlt } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import { FiChevronRight, FiPlus } from "react-icons/fi";
import { FiChevronLeft } from "react-icons/fi";
import { BsCheck, BsMap } from "react-icons/bs";
import { BsX } from "react-icons/bs";

//component
//setselecteditem envia o usuário para o formulário da página Tecnicos
//setselectedtec envia o usuário para o a agenda da página Agenda
const DatagridUsers = ({
	token,
	setSelectedItem,
	openForm,
	setOpenForm,
	setSelectedTec,
	setPopup
}) => {
	//navegação
	const navigate = useNavigate();

	const [delItem, setdelItem] = useState({}); //item a ser deletado
	const [loading, setLoading] = useState(false); //pagina atual do grid

	const [search, setSearch] = useState(""); //barra de pesquisa
	const [page, setPage] = useState(0); //página atual
	const [tecnicos, setTecnicos] = useState([]); //conjunto de usuários mutável
	const [tecnicosAll, setTecnicosAll] = useState([]); //conjunto de todos os usuários
	const [tecnicosPage, setTecnicosPage] = useState([]); //usuários da página atual
	const limit = 4; //limite de usuarios por página

	//botão bolinha estilizado
	const StyledBtn = ({ icon, stl, text, event }) => {
		const [onhover, setonhover] = useState(false);
		return (
			<div
				onClick={event}
				onMouseOver={() => {
					setonhover(true);
				}}
				onMouseOut={() => {
					setonhover(false);
				}}
				className={stl}
			>
				{onhover ? text : icon}
			</div>
		);
	};

	//verifica se o botão avançar e voltar página estão habilitados
	//conforme a página atual e as páginas seguintes
	const handlePageAble = (button) => {
		switch (button) {
			case "left":
				if (page === 0) {
					return false;
				} else {
					return true;
				}
			case "right":
				if (page < tecnicos.length / limit - 1) {
					return true;
				} else {
					return false;
				}

			default:
				break;
		}
	};

	//deleta um técnico
	const handleDelete = (item) => {
		//função que efetivamente envia a request de delet
		const delItem = (id) => {
			let config = { headers: { "x-access-token": token } };
			let object = {
				id: id,
			};
			Requests.deleteTecnicos(object, config)
				.then((res) => {
					if (res.affectedRows > 0) {
						setdelItem({});
						loadContent();
						setLoading(true);
						setTimeout(() => {
							toast.success("Usuário excluido com sucesso!");
							setLoading(false);
						}, 1500);
					} else {
						toast.error("Não foi possível excluir o usuário");
					}
				})
				.catch((err) => {
					toast.error("Não foi possível excluir o usuário");
					console.log(err);
				});
		};

		//abre o popup de confirmação de exclusão
		if (item.id) {
			return (
				<div className="popup-wrapper">
					<p>{"DELETAR USUÁRIO?"}</p>
					<p>
						{"O usuário "}
						<b>{item.nome}</b>
						{" está prestes a ser excluido, deseja realmente prosseguir?"}
					</p>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<StyledBtn
							event={() => {
								setdelItem({});
							}}
							text={"cancelar"}
							icon={<BsX />}
							stl="btn-nok"
						></StyledBtn>
						<StyledBtn
							event={() => {
								delItem(item.id);
							}}
							text={"excluir"}
							icon={<BsCheck />}
							stl="btn-ok"
						></StyledBtn>
					</div>
				</div>
			);
		}
	};

	//gerencia a barra de pesquisa
	const handleSearch = () => {
		let filtered;
		filtered = tecnicosAll.filter((a) => {
			return a.nome.toLowerCase().includes(search.toLocaleLowerCase());
		});
		setTecnicos(filtered);
		handleChangePage(filtered);
	};

	//gerencia a troca de página
	const handleChangePage = (t = tecnicos) => {
		let actualRotas = [];
		for (let i = limit * page; i < limit * page + limit; i++) {
			if (t[i]) {
				actualRotas.push(t[i]);
			}
		}
		setTecnicosPage(actualRotas);
	};

	//carrega as rotas do banco
	const loadContent = () => {
		let config = { headers: { "x-access-token": token } };
		Requests.getTecnicos(config)
			.then((res) => {
				if (res) {
					let content = res.sort((a, b) => {
						return a.nome.localeCompare(b.nome);
					});

					Requests.getGestores(config)
						.then((res) => {
							if (res) {
								let newContent = res.sort((a, b) => {
									return a.nome.localeCompare(b.nome);
								});

                                content.push(...newContent);

                                content = content.sort((a, b) => {
                                    return a.nome.localeCompare(b.nome);
                                });
                                
								//lógica que gerencia as páginas do dgrid
								let startContent = [];
								for (let i = limit * page; i < limit * page + limit; i++) {
									if (content[i]) {
										startContent.push(content[i]);
									}
								}
								//setta os states com o resultado da request
								setTecnicos(content);
								setTecnicosAll(content);
								setTecnicosPage(startContent);
								setPage(0);
							}
						})
						.catch((res, err) => {
							console.log(res, err);
						});
				}
			})
			.catch((res, err) => {
				console.log(res, err);
			});
	};

	//carrega o conteudo
	useEffect(() => {
		loadContent();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//watcher da barra de pesquisa, para não bugar o loadcontent da página
	useEffect(() => {
		if (search) {
			handleChangePage(tecnicos);
		} else {
			handleChangePage();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	return (
		<div className="datagrid-tecnicos-body">
			<Toaster />
			{/* popup */}
			{handleDelete(delItem)}
			{/* datagrid */}
			<fieldset className="datagrid-tecnicos-container">
				<legend> Técnicos Cadastrados </legend>
				{/* barra de pesquisa */}
				<InputSearch
					handleSearch={handleSearch}
					search={search}
					setSearch={setSearch}
					size="full"
					placeholder="Tecnicos..."
				></InputSearch>
				{/* verifica se está carregando e retorna os itens de cada rota */}
				{!loading ? (
					<div id="dg-list">
						{tecnicosPage.map((element, i) => {
							return (
								<div className="datagrid-tecnicos-item" key={"rota-" + i}>
									<p>{element.nome}</p>
									<div className="buttons">
										{setPopup ? <StyledBtn
											event={() => {
												setSelectedTec(element);
												let path = "/mapa";
												navigate(path)
												setPopup();
											}}
											text={"Mapa"}
											icon={<BsMap />}
											stl="btn-agenda"
										></StyledBtn> :
										<StyledBtn
											event={() => {
												setSelectedTec(element);
												let path = "/agenda";
												navigate(path)
											}}
											text={"Agenda"}
											icon={<BiCalendar />}
											stl="btn-agenda"
										></StyledBtn>}
										<StyledBtn
											event={() => {
												setOpenForm(true);
												setSelectedItem(element);
											}}
											text={"Editar"}
											icon={<FaRegEdit />}
											stl="btn-edit"
										></StyledBtn>
										<StyledBtn
											event={() => setdelItem(element)}
											text={"Deletar"}
											icon={<FaTrashAlt />}
											stl="btn-delet"
										></StyledBtn>
									</div>
								</div>
							);
						})}
					</div>
				) : (
					<div id="dg-list" className="refresh-page">
						<BiRefresh />
					</div>
				)}
				{/* rotdapé onde estão os botões de passar página */}
				<div className="datagrid-tecnicos-footer">
					<div
						onClick={async () => {
							setSelectedItem({});
							loadContent();
							setLoading(true);
							setTimeout(() => {
								setLoading(false);
							}, 1500);
						}}
					>
						<StyledBtn
							text={"Recarregar"}
							icon={<BiRefresh />}
							stl="btn-refresh"
						></StyledBtn>
					</div>
					{/* demonstra quais itens estão no dgrid */}
					<p>
						{limit * page +
							1 +
							"-" +
							(limit * page + limit) +
							" de " +
							tecnicos.length}
					</p>
					{handlePageAble("left") ? (
						<FiChevronLeft
							className="enable"
							onClick={() => {
								setLoading(true);
								setTimeout(() => {
									setPage(page - 1);
									setLoading(false);
								}, 200);
							}}
						/>
					) : (
						<FiChevronLeft />
					)}
					{handlePageAble("right") ? (
						<FiChevronRight
							className="enable"
							onClick={() => {
								setLoading(true);
								setTimeout(() => {
									setPage(page + 1);
									setLoading(false);
								}, 200);
							}}
						/>
					) : (
						<FiChevronRight />
					)}
				</div>
			</fieldset>
			<p onClick={() => setOpenForm(!openForm)} className="cadastro-tecnico">
                <span>Cadastrar Técnico <FiPlus /></span>
            </p>
		</div>
	);
};

export default DatagridUsers;
